import { render, staticRenderFns } from "./ChallengeView.vue?vue&type=template&id=68befc46&scoped=true&"
import script from "./ChallengeView.vue?vue&type=script&lang=js&"
export * from "./ChallengeView.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeView.vue?vue&type=style&index=0&id=68befc46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68befc46",
  null
  
)

export default component.exports